export class UpdateResourceSecurityScansExclusionRequest {
    'excluded';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "excluded",
            "baseName": "excluded",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateResourceSecurityScansExclusionRequest.attributeTypeMap;
    }
    constructor() {
    }
}
